import React, { useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import { ICONS } from '../../img/icons'
import Icon from '../../img/Icon'
import Modal from 'react-bootstrap/Modal'
import { useTranslation } from 'react-i18next';
import { chartMode } from '../../constants';
import ChartModal from './ChartModal';

import '../../css/general.css'
import '../../css/farmPlot.css'

const ShowDValuesListModal = (props) => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(true);
    const [dValueData, setDValueData] = useState([]);
    const [chartModalShow, setChartModalShow] = useState(false);
    const [chartModalData, setChartModalData] = useState([]);
    const [hideContent, setHideContent] = useState(false);

    useEffect(() => {
        var sortedData = props.data.sort((a, b) => {
            return a.dValue - b.dValue;
        });
        setDValueData(sortedData);
        setIsLoading(false);
    }, [props.data]);

    const openDValueGraph = (data) => {
        setChartModalData(data);
        setChartModalShow(true);
        setHideContent(true);
    }

    return (
        <>
            <Modal show={props.show} onHide={props.onHide}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-dark">{t('DValue')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(isLoading) ? <Spinner animation="border" variant="success" />
                        :
                        <ListGroup>
                            {(dValueData && !hideContent) ? dValueData.map((d, i) =>
                                <div key={i}>
                                    <ListGroup.Item
                                        className="plotItemStyle"
                                        action
                                        onClick={() => { openDValueGraph(d); }}
                                    >
                                        <div className='row-icon-right'><Icon icon={ICONS.ARROW_RIGHT} color='gray' size='36' /></div>
                                        <div className="operation-list-name">{d.plotName} - {d.plotLetter}</div>
                                        <div>{d.dValue}</div>
                                    </ListGroup.Item>
                                </div>
                            ) : ""}
                        </ListGroup>}
                </Modal.Body>
                {!hideContent ?
                    <Modal.Footer className="modal-footer-right-align">
                        <Button variant="outline-secondary" onClick={props.onHide}>{t('Close')}</Button>
                    </Modal.Footer>
                    : ''}
            </Modal>
            {chartModalShow === true ?
                <ChartModal
                    show={chartModalShow}
                    data={chartModalData}
                    chartMode={chartMode.dValue}
                    onHide={() => {
                        setChartModalShow(false);
                        setHideContent(false);
                    }}
                />
                : ''}
        </>
    )
}

export default ShowDValuesListModal;